export default "__VITE_ASSET___97k4mtO__"